import React, { useRef, useState } from 'react';
import logo from '../../assets/icons/logo.svg';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/free-solid-svg-icons/faBars";
import './_navbar.scss';

export const handleClickNav = (id: string) => {
    const element = document.getElementById(id);

    if (element) {
        element.scrollIntoView({ behavior: "smooth" , block: "center"});
    }
}

export enum SectionId {
    LANDING = 'landing',
    ABOUT = 'about',
    PROJECTS = 'projects',
    CONTACT = 'contact',
    FOOTER = 'footer'
}

const Navbar = () => {
    const [showLinks, setShowLinks] = useState(false);

    const navLinkObjects: { title: string; id: string }[] = [
        { title: 'Avaleht', id: SectionId.LANDING },
        { title: 'Firmast', id: SectionId.ABOUT},
        { title: 'Tehtud tööd', id: SectionId.PROJECTS },
        { title: 'Kontakt', id: SectionId.CONTACT }
    ]

    const renderNavLink = (link: { title: string; id: string }) => {
        return (
            <li>
                <a onClick={() => handleClickMobile(link.id)}>{link.title}</a>
            </li>
        )
    }

    const handleClickMobile = ( id: string ) => {
        handleClickNav(id);
        setShowLinks(false);
    }

    let navRef = useRef<HTMLInputElement | null>(null);

    return (
        <div className="nav-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-6 siteId">
                        <img onClick={() => handleClickMobile('landing')} src={logo} className="site-logo" alt="Logo"/>
                        <h2>Vannitoameister</h2>
                    </div>

                    <div className="col-6 siteNav">
                        <div ref={navRef} className="nav-links" id={showLinks ? "hidden" : ""}>
                            <ol>
                                {navLinkObjects.map((link) => renderNavLink(link))}
                            </ol>
                        </div>
                        <FontAwesomeIcon onClick={() => setShowLinks(!showLinks)} className="mobile-nav-toggle" icon={faBars} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
